import dayjs from 'dayjs'

import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { dateFormat } from 'shared/lib/dateFormat'

/**
 * Парсит время в формате "HH:mm" или "HH:mm:ss".
 * Возвращает { hour, minute } или null при невалидной строке.
 */
function parseTime(timeStr: string): { hour: number; minute: number } | null {
  const trimmed = timeStr.trim()
  const match = trimmed.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/)
  if (!match) return null
  const hour = parseInt(match[1], 10)
  const minute = parseInt(match[2], 10)
  if (hour < 0 || hour > 23 || minute < 0 || minute > 59) return null
  return { hour, minute }
}

export const calculateFreeCancellationDate = (
  startDate?: string,
  freeCancellationMinutes?: number,
  startTime?: string,
): string | null => {
  if (
    !startDate ||
    freeCancellationMinutes === undefined ||
    freeCancellationMinutes < 0
  ) {
    return null
  }

  let checkIn = dayjs(startDate)

  if (!checkIn.isValid()) {
    return null
  }

  const parsedTime = startTime ? parseTime(startTime) : null
  if (parsedTime) {
    checkIn = checkIn
      .hour(parsedTime.hour)
      .minute(parsedTime.minute)
      .second(0)
      .millisecond(0)
  }

  const cancellationMoment = checkIn.subtract(freeCancellationMinutes, 'minute')

  const datePart = dateFormat(
    cancellationMoment.format(DATE_FORMAT_LIST.YEAR_FULL_DATE),
    DATE_FORMAT_LIST.DATE_MONTH,
  )

  return parsedTime
    ? `${datePart}, ${cancellationMoment.format(DATE_FORMAT_LIST.TIME)}`
    : datePart
}
